// src/containers/copyright_text/index.js
import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import Scroll from '../scroll/index';
import './copyright.scss';

function CopyRight() {
  const year = new Date().getFullYear();

  return (
    <div className="footer-wrapper-copytext">
      <Container>
        <div className="footer-copyright-text">
          <div className="copyright-link">
            <span>© {year} Smart Board Learning™ All Rights Reserved.</span>
            <span className="copyright-sep" aria-hidden="true">•</span>
            <span className="copyright-pages">
              <Link to="/terms-of-service">Terms &amp; Conditions</Link>
              <span className="copyright-sep" aria-hidden="true">/</span>
              <Link to="/privacy-policy">Privacy &amp; Policy</Link>
            </span>
          </div>
          <Scroll />
        </div>
      </Container>
    </div>
  );
}

export default CopyRight;
